import React, { Component } from 'react';
import { Input } from "@progress/kendo-react-inputs";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery'
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';

class myInputCellNLote extends Component {

  // handleChange = e => {

  //   var resultString = 'L'

  //   if($.isNumeric(e.value.substring(1))){

  //     resultString += e.value.substring(1);

  //   }else if(!$.isNumeric(e.nativeEvent.data) && e.value.substring(1).length > 0){

  //     resultString += e.value.replace(e.nativeEvent.data,'').replace('L','');

  //   }

  //   this.props.dataItem.NLote = resultString;

  //   this.props.onChange({
  //     dataIndex: 0,
  //     dataItem: this.props.dataItem,
  //     field: this.props.field,
  //     syntheticEvent: e.syntheticEvent,
  //     value: resultString
  //   });

  // }
  handleChange = e => {

    // var resultString = 'L'

    // if($.isNumeric(e.value.substring(1)) || $.isNumeric(e.value.substring(0)) ){

    //   resultString += e.value.substring(1);

    // }else if(!$.isNumeric(e.nativeEvent.data) && e.value.substring(0).length > 0){

    //   resultString = e.value;

    // }else{
    //   resultString = ""
    // }

    // this.props.dataItem.NLote = resultString;

    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.value
    });

  }
  componentDidMount = () => {

    

  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    console.log('InputCellNLoteInputCellNLoteInputCellNLote')

    return (
        <td>
            {dataItem.inEdit ?
              <Input type="text"
                name={field}
                className='col-12'
                onChange={this.handleChange}
                value={dataValue != null ? dataValue.toString() : ''}  
              />
            : dataValue != null ? dataValue.toString() : undefined}
        </td>
    );
  }
}

export default myInputCellNLote;